import { Component, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerImageType } from '../models/enums/customer-image-type.enum';
import { CustomerImageService } from '../shared/customer-image.service';
import { CustomerImageOOJService } from '../shared/customer-image-ooj.service';

@Component({
    selector: 'customer-photo',
    templateUrl: './customer-photo.html',
    inputs: ['customerNumberId', 'legacySequenceNumber', 'credentialNumberId', 'imageId', 'ident', 'imageType', 'jurisdictionCode', 'credentialNumber', 'classes', 'businessTransactionNumberId']
})
export class CustomerPhotoComponent extends BaseComponent implements OnChanges {

    // Inputs
    public customerNumberId: number;
    public legacySequenceNumber: string;
    public credentialNumberId: number;
    public imageId: string;
    public ident: string;
    public jurisdictionCode: string;
    public credentialNumber: string;    // DriverLicenseNumber
    public imageType: CustomerImageType = CustomerImageType.TOP_OF_STACK;
    public classes = 'mvd_photo';
    public businessTransactionNumberId: number;

    // logic
    public imageUrl: any = 'dist/MaxWeb/assets/images/customer-photo.svg';
    public imageStyle: any = 'url(dist/MaxWeb/assets/images/customer-photo.svg)';

    constructor(
        private _imageService: CustomerImageService,
        private _imageOOJService: CustomerImageOOJService,
        private _sanitizer: DomSanitizer) {
        super();
    }

    public ngOnInit() {
        // ngOnChanges Fires before ngOnInit
    }

    public ngOnChanges() {
        this.loadImage();
    }

    public loadImage = (): void => {
        let observable = this.getObservable(this.imageType);

        if (null != observable) {
            observable.subscribe(content => {
                if ((null != content) && (null != content.result)) {
                    let url = `data:image/jpg;base64,${content.result}`;
                    this.imageUrl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
                    this.imageStyle = this._sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
                }
            });
        }
    };

    public getObservable(imageType: CustomerImageType): Observable<{ result: string }> {
        switch (imageType) {
            case CustomerImageType.RECENT: {
                if (this.customerNumberId) {
                    return this._imageService.getRecentPortrait(this.customerNumberId);
                }
                break;
            }
            case CustomerImageType.CREDENTIAL: {
                if (this.credentialNumberId) {
                    return this._imageService.getDriverCredentialPortrait(this.credentialNumberId);
                }
                break;
            }
            case CustomerImageType.DRIVER_DEFAULT: {
                if (this.imageId) {
                    return this._imageService.getDriverPortrait(this.imageId);
                }
                break;
            }
            case CustomerImageType.UNASSOCIATED: {
                if (this.ident) {
                    return this._imageService.getDriverPhotoUnassociated(this.ident);
                }
                break;
            }
            case CustomerImageType.OUT_OF_JURISDICTION: {
                if (this.jurisdictionCode && this.credentialNumber) {
                    return this._imageOOJService.getDriverImage(this.jurisdictionCode, this.credentialNumber);
                }
                break;
            }
            case CustomerImageType.ISSUANCE_TRANSACTION: {
                if (!!this.businessTransactionNumberId) {
                    return this._imageService.getTransactionPortrait(this.businessTransactionNumberId);
                }
            }
            case CustomerImageType.TOP_OF_STACK:
            default: {
                if (this.customerNumberId) {
                    return this._imageService.getDriverTopOfStackPortrait(this.customerNumberId);
                }
            }
        }
        return null;
    }
}
